import { Button, Form, Switch, Transfer } from "antd";
import SimpleTransfer from "../common/SimpleTransfer";
import { useEffect, useState } from "react";
import { api } from "../common/api";
import { downloadFile, downloadZip } from "../common/common";
import { ExportOutlined } from "@ant-design/icons";

export default function () {
  const [employees, setEmployees] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [tags, setTags] = useState([]);

  useEffect(() => {
    api.employee.list({ pageSize: 99999 }).then(({ data }) =>
      setEmployees(
        data.map((e) => ({
          key: e.id,
          title: e.fullName,
        })),
      ),
    );
    api.vehicle.list({ pageSize: 99999 }).then(({ data }) =>
      setVehicles(
        data.map((e) => ({
          key: e.id,
          title: e.plate + " " + e.description,
        })),
      ),
    );

    api.tag.list({ pageSize: 99999 }).then(({ data }) =>
      setTags(
        data.map((e) => ({
          key: e.id,
          title: e.name,
        })),
      ),
    );
  }, []);

  const onFinish = (formData) => {
    api.docExport
      .export(formData)
      .then(({ data }) => window.open(`/api/v1/docExport/${data.id}`, "_blank"));
    //TODO: download con progress non alla fine
  };

  return (
    <Form
      layout={"vertical"}
      onFinish={onFinish}
      initialValues={{
        vehicles: [],
        employees: [],
        tags: [],
        includeDpi: false,
        includeMedicalFitness: false,
      }}
    >
      <Form.Item name={"includeDpi"} label={"Includi consegne DPI"} valuePropName={"checked"}>
        <Switch />
      </Form.Item>
      <Form.Item
        name={"includeMedicalFitness"}
        label={"Includi Idoneità"}
        valuePropName={"checked"}
      >
        <Switch />
      </Form.Item>
      <Form.Item name={"employees"} label={"Dipendenti"}>
        <SimpleTransfer dataSource={employees} />
      </Form.Item>
      <Form.Item name={"vehicles"} label={"Dipendenti"}>
        <SimpleTransfer dataSource={vehicles} />
      </Form.Item>
      <Form.Item name={"tags"} label={"Tag"}>
        <SimpleTransfer dataSource={tags} />
      </Form.Item>
      <Form.Item>
        <Button htmlType={"submit"} type={"primary"} icon={<ExportOutlined />}>
          Esporta
        </Button>
      </Form.Item>
    </Form>
  );
}
